<template>
  <div>
    <provisioning-status @refresh="reload" />
    <v-card class="main-card">
      <!-- タイトル・状態文言 -->
      <v-card-title class="screen-title">
        <span>契約・設定一覧</span>
        <manual-button path="/ap-overview/" />
      </v-card-title>
      <!-- アプライアンスオブジェクト設定：一覧 -->
      <v-card-text class="pa-2" v-if="isLoaded">
        <v-row no-gutters justify="end">
          <div class="d-flex justify-end ga-1 flex-wrap ml-2">
            <v-btn
              color="info"
              v-permission.kddiAdmin
              @click="showImportContract"
              >Type4契約インポート</v-btn
            >
            <template v-if="!user.contractSummary.isLargeScaleContract">
              <v-btn
                color="primary"
                v-permission.admin
                @click="showPolicyRegister"
                >追加</v-btn
              >
            </template>
            <v-btn
              color="primary"
              v-permission.notViewDelegate
              @click="showOptionReference"
              >オプション設定</v-btn
            >
            <v-btn
              color="primary"
              v-permission.config
              v-if="isDetailLoaded && selectedItem?.internetType === 'TYPE1'"
              @click="changeType1InternetStatus"
              >インターネット接続/一時停止</v-btn
            >
            <v-btn
              v-if="
                type4SelectedItem.status === 'UNCONNECTED' &&
                isDetailLoaded &&
                selectedItem?.internetType === 'TYPE4'
              "
              color="primary"
              v-permission.admin
              @click="changeType4InternetStatus"
              >インターネット接続/一時停止</v-btn
            >
            <v-btn
              v-if="
                type4SelectedItem.status !== 'UNCONNECTED' &&
                isDetailLoaded &&
                selectedItem?.internetType === 'TYPE4'
              "
              color="primary"
              v-permission.config
              @click="changeType4InternetStatus"
              >インターネット接続/一時停止</v-btn
            >
          </div>
        </v-row>
        <v-row no-gutters justify="space-between" class="my-2" align="center">
          <span>{{ applianceObjectTable.items.length }}件表示</span>
          <v-btn color="primary" @click="reload">一覧更新</v-btn>
        </v-row>
        <div class="mb-4">
          <app-table
            v-model:table-sort-by="applianceObjectTable.sortBy"
            primary-key="_id"
            :fields="applianceObjectTable.fields"
            :items="applianceObjectTable.items"
            :sort-null-last="true"
            :hover="true"
            :per-page="-1"
            @click:row="setSelectedItem"
            :tr-class="rowHighlight"
          >
            <!-- lineNumber -->
            <template #cell(lineNumber)="data">
              {{ $filter.emptyTo(data.value, "-") }}
            </template>
            <!-- Type4ID -->
            <template #cell(type4Id)="data">
              {{ $filter.emptyTo(data.value, "-") }}
            </template>
            <!-- type4Name -->
            <template #cell(type4Name)="data">
              {{ $filter.emptyTo(data.value, "-") }}
            </template>
            <!-- メインサイト -->
            <template #cell(mainSite)="data">
              {{ $filter.emptyTo($filter.enumTo(data.value, "mainSite"), "-") }}
            </template>
            <!-- セキュリティ監視 -->
            <template #cell(isSecurityOption)="data">
              <template v-if="user.contractSummary.isSecuritySetting">
                <template v-if="data.item.internetType === 'INTRANET'"
                  >-</template
                >
                <template v-else
                  >{{ $filter.enumTo(data.item.isSecurityOption, "on_off") }}
                </template>
              </template>
            </template>
            <!-- 状態 -->
            <template #cell(status)="data">
              {{ $filter.emptyTo(data.value, "-") }}
            </template>
          </app-table>
        </div>
        <!-- ポリシー設定：詳細 -->
        <!--        Type1-->
        <template
          v-if="isDetailLoaded && selectedItem?.internetType === 'TYPE1'"
        >
          <v-card-title class="screen-title"
            ><span
              >インターネット・セキュリティアプライアンス契約参照</span
            ></v-card-title
          >
          <v-card-text>
            <v-row no-gutters justify="end" class="mt-4">
              <div class="d-flex ga-1 flex-wrap">
                <v-btn
                  color="primary"
                  v-permission.config
                  @click="showType1ZoneRelationSettingList"
                  >ゾーン接続設定</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.notViewDelegate
                  @click="showType1PolicySetting"
                  >ポリシー設定</v-btn
                >
                <div class="d-flex ga-1 flex-wrap ml-5">
                  <v-btn
                    color="primary"
                    v-permission.admin
                    @click="showType1ContractApplianceModify"
                    >アプライアンス契約</v-btn
                  >
                  <v-btn
                    color="primary"
                    v-permission.admin
                    @click="showType1ContractModify"
                    >契約変更</v-btn
                  >
                  <v-btn
                    color="primary"
                    v-permission.notViewDelegate
                    @click="downloadNetWorkInformation"
                    >設定情報ダウンロード</v-btn
                  >
                </div>
              </div></v-row
            >
            <!-- 詳細項目部分 -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >インターネットType1</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="VPNコード"
                  :value="type1SelectedItem.vpnCode"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="回線番号(メイン)"
                  :value="`${type1SelectedItem.enumberMainAct}/${type1SelectedItem.enumberMainSby}`"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="回線番号(BCP)"
                  :value="`${type1SelectedItem.enumberBcpAct}/${type1SelectedItem.enumberBcpSby}`"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group label="Type" value="インターネットType1" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">アプライアンス</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group label="セキュリティアプライアンス">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-if="type1SelectedItem.applianceType === 'UTM'"
                      >
                        UTM(1Gbpsベストエフォート)
                      </template>
                      <template
                        v-if="type1SelectedItem.applianceType === 'IFW'"
                      >
                        インターネットFW(帯域確保型{{
                          type1SelectedItem.bandwidth?.value
                        }}{{
                          $filter.enumTo(
                            type1SelectedItem.bandwidth?.unit,
                            "bandwidth_unit"
                          )
                        }})
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
              <v-col cols="4" v-if="user.contractSummary.isSecuritySetting">
                <app-label-group
                  label="セキュリティ監視オプション"
                  :value="
                    $filter.enumTo(type1SelectedItem.isSecurityOption, 'on_off')
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group label="インターネット帯域">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-if="type1SelectedItem.applianceType === 'UTM'"
                      >
                        1Gbpsベストエフォート
                      </template>
                      <template
                        v-if="type1SelectedItem.applianceType === 'IFW'"
                      >
                        帯域確保型{{ type1SelectedItem.bandwidth?.value
                        }}{{
                          $filter.enumTo(
                            type1SelectedItem.bandwidth?.unit,
                            "bandwidth_unit"
                          )
                        }}
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
              <v-col cols="4">
                <app-label-group label="NAT契約">
                  <template #value>
                    <div class="ml-3">
                      {{
                        $filter.enumTo(
                          contractGetType1Appliance.natEnabled,
                          "contractStatus"
                        )
                      }}(ルール数
                      {{ contractGetType1Appliance.natRuleCount }}個)
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">オプション</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="払出済みグローバルIP数"
                  :value="`${type1SelectedItem.globalIpAddressList.length}個`"
                />
              </v-col>
              <v-col cols="8">
                <app-label-group
                  label="状態"
                  :value="$filter.enumTo(type1SelectedItem.status, 'status')"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group label="グローバルIP">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-for="(
                          item, index
                        ) in type1SelectedItem.globalIpAddressList"
                        :key="index"
                      >
                        <div>
                          {{ item.globalIpAddress }}
                          <span v-if="item.isInitialAddress">
                            (デフォルト)</span
                          >
                        </div>
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <!--        Type4-->
        <template
          v-if="isDetailLoaded && selectedItem?.internetType === 'TYPE4'"
        >
          <v-card-title class="screen-title"
            ><span
              >インターネット・セキュリティアプライアンス契約参照</span
            ></v-card-title
          >
          <v-card-text>
            <v-row no-gutters justify="end" class="mt-4">
              <div class="d-flex justify-end ga-1 flex-wrap">
                <v-btn
                  color="info"
                  v-permission.kddiAdmin
                  @click="showImportConfig"
                  >Type4設定インポート</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.notViewDelegate
                  @click="showType4PolicySetting"
                  >ポリシー設定</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.notViewDelegate
                  @click="showType4Route"
                  >経路設定</v-btn
                >
                <v-btn
                  class="ml-5"
                  color="primary"
                  v-permission.admin
                  @click="showType4ContractModify"
                  >契約変更</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.admin
                  @click="showType4PolicyDelete"
                  >削除</v-btn
                >
              </div></v-row
            >
            <!-- 詳細項目部分 -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >インターネットType4</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group label="VPN/VNコード">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-if="type4SelectedItem.vpnVnCode.charAt(0) !== 'B'"
                      >
                        {{
                          `${type4SelectedItem.vpnVnCode}(${type4SelectedItem.vnName})`
                        }}
                      </template>
                      <template v-else>
                        {{ type4SelectedItem.vpnVnCode }}
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
              <v-col cols="4">
                <app-label-group label="回線番号(メイン)">
                  <template #value>
                    <div class="ml-3">
                      {{
                        `${type4SelectedItem.wnumberMainAct}/${type4SelectedItem.wnumberMainSby}`
                      }}
                      [{{
                        $filter.enumTo(type4SelectedItem.mainSite, "mainSite")
                      }}]
                    </div>
                  </template>
                </app-label-group>
              </v-col>
              <v-col cols="4">
                <app-label-group label="回線番号(BCP)">
                  <template #value>
                    <div class="ml-3">
                      {{
                        `${type4SelectedItem.wnumberBcpAct}/${type4SelectedItem.wnumberBcpSby}`
                      }}
                      [{{
                        $filter.enumTo(
                          type4SelectedItem.mainSite === "TOKYO"
                            ? "OSAKA"
                            : "TOKYO",
                          "mainSite"
                        )
                      }}]
                    </div></template
                  >
                </app-label-group>
              </v-col>
              <v-col cols="4">
                <app-label-group label="Type" value="インターネットType4" />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="Type4ID"
                  :value="type4SelectedItem.type4Id"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="Type4名"
                  :value="type4SelectedItem.type4Name"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="メインサイト"
                  :value="
                    $filter.enumTo(type4SelectedItem.mainSite, 'mainSite')
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">アプライアンス</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group label="セキュリティアプライアンス">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-if="type4SelectedItem.applianceType === 'IFW'"
                      >
                        インターネットFW(100Mbpsベストエフォート)
                      </template>
                      <template
                        v-if="
                          type4SelectedItem.applianceType === 'UTM' &&
                          type4SelectedItem.contractType === 'BEST_EFFORT'
                        "
                      >
                        UTM(1Gbpsベストエフォート)
                      </template>
                      <template
                        v-if="
                          type4SelectedItem.applianceType === 'UTM' &&
                          type4SelectedItem.contractType === 'SECURING'
                        "
                      >
                        UTM(帯域確保型{{ type4SelectedItem.bandwidth?.value
                        }}{{
                          $filter.enumTo(
                            type4SelectedItem.bandwidth?.unit,
                            "bandwidth_unit"
                          )
                        }})
                      </template>
                    </div></template
                  >
                </app-label-group>
              </v-col>
              <v-col cols="4" v-if="user.contractSummary.isSecuritySetting">
                <app-label-group
                  label="セキュリティ監視オプション"
                  :value="
                    $filter.enumTo(type4SelectedItem.isSecurityOption, 'on_off')
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group label="インターネット帯域">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-if="type4SelectedItem.applianceType === 'IFW'"
                      >
                        100Mbpsベストエフォート
                      </template>
                      <template
                        v-if="
                          type4SelectedItem.applianceType === 'UTM' &&
                          type4SelectedItem.contractType === 'BEST_EFFORT'
                        "
                      >
                        1Gbpsベストエフォート
                      </template>
                      <template
                        v-if="
                          type4SelectedItem.applianceType === 'UTM' &&
                          type4SelectedItem.contractType === 'SECURING'
                        "
                      >
                        帯域確保型{{ type4SelectedItem.bandwidth?.value
                        }}{{
                          $filter.enumTo(
                            type4SelectedItem.bandwidth?.unit,
                            "bandwidth_unit"
                          )
                        }}
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">オプション</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="払出済みグローバルIP数"
                  :value="`${type4SelectedItem.globalIpAddressList.length}個`"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="M365経路制御オプション"
                  :value="
                    $filter.enumTo(type4SelectedItem.isMicrosoft365, 'on_off')
                  "
                ></app-label-group>
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="状態"
                  :value="$filter.enumTo(type4SelectedItem.status, 'status')"
                ></app-label-group>
              </v-col>
              <v-col cols="12">
                <app-label-group label="グローバルIP">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-for="(
                          item, index
                        ) in type4SelectedItem.globalIpAddressList"
                        :key="index"
                      >
                        <div>
                          {{ item.globalIpAddress }}
                          <span v-if="item.isInitialAddress">
                            (デフォルト)</span
                          >
                        </div>
                      </template>
                    </div></template
                  >
                </app-label-group>
              </v-col>
            </v-row>
            <template v-if="type4SelectedItem.contractInfo">
              <v-row>
                <v-col>
                  <span class="text-h6 font-weight-bold">契約情報</span>
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="4">
                  <app-label-group
                    label="契約者名"
                    :value="
                      $filter.emptyTo(
                        type4SelectedItem.contractInfo.contractor,
                        '-'
                      )
                    "
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="メールアドレス"
                    :value="type4SelectedItem.contractInfo.email"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="エンドユーザ名"
                    :value="type4SelectedItem.contractInfo.endUserName"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">保守連絡先情報</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <template v-if="type4SelectedItem.maintenance">
                <v-col cols="4">
                  <app-label-group
                    label="会社名"
                    :value="type4SelectedItem.maintenance.company"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="部署名"
                    :value="type4SelectedItem.maintenance.department"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="担当者名"
                    :value="type4SelectedItem.maintenance.name"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="電話番号"
                    :value="type4SelectedItem.maintenance.phone"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="メールアドレス"
                    :value="type4SelectedItem.maintenance.email"
                  />
                </v-col>
              </template>
              <v-col v-else cols="4">-</v-col>
            </v-row>
          </v-card-text>
        </template>
        <!--        イントラネットFW-->
        <template
          v-if="isDetailLoaded && selectedItem?.internetType === 'INTRANET'"
        >
          <v-card-title class="screen-title"
            ><span>イントラネットFW契約参照</span></v-card-title
          >
          <v-card-text>
            <v-row no-gutters justify="end" class="mt-4">
              <div class="d-flex justify-end ga-1 flex-wrap">
                <v-btn
                  color="primary"
                  @click="showIntranetFwContractChange"
                  v-permission.admin
                  >契約変更</v-btn
                >
              </div>
            </v-row>
            <!-- 詳細項目部分 -->
            <v-row class="px-4">
              <v-col cols="12">
                <app-label-group
                  label="VPNコード"
                  :value="intranetFwSelectedItem.vpnCode"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group label="セキュリティアプライアンス">
                  <template #value>
                    <div class="ml-3">
                      イントラネットFW({{
                        intranetFwSelectedItem.intranetFwBandwidth.value
                      }}{{
                        $filter.enumTo(
                          intranetFwSelectedItem.intranetFwBandwidth.unit,
                          "bandwidth_unit"
                        )
                      }})
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
            <!-- サブカード：リモートアクセスゲートウェイ -->
            <v-card
              class="main-card"
              v-if="
                intranetFwSelectedItem.accessLineList.length > 0 ||
                intranetFwSelectedItem.remoteAccessGwList.length > 0
              "
            >
              <v-card-title class="screen-title"
                >アクセス回線・リモートアクセスゲートウェイ</v-card-title
              >
              <v-card-text>
                <v-row no-gutters justify="end" class="mt-4">
                  <div class="d-flex justify-end ga-1 flex-wrap">
                    <v-btn
                      color="primary"
                      @click="showIntranetFwZoneRelation"
                      v-permission.config
                      >ゾーン接続設定</v-btn
                    >
                    <v-btn
                      color="primary"
                      v-permission.notViewDelegate
                      @click="showServiceSetting('INTRANET_FW')"
                      >個別サービス設定</v-btn
                    >
                    <v-btn
                      color="primary"
                      v-permission.notViewDelegate
                      @click="showIntranetFwPolicySetting"
                      >ポリシー設定</v-btn
                    >
                  </div>
                </v-row>
                <!-- サブタイトル：アクセス回線 -->
                <template
                  v-if="intranetFwSelectedItem.accessLineList.length > 0"
                >
                  <v-row>
                    <v-col>
                      <span class="text-h7 font-weight-bold">アクセス回線</span>
                    </v-col>
                  </v-row>
                  <v-row class="px-4 ma-4">
                    <v-col
                      v-for="(
                        item, index
                      ) in intranetFwSelectedItem.accessLineList"
                      :key="index"
                      cols="4"
                      ><div>
                        {{ item.enumber }}&ensp;&ensp;{{
                          item.bandwidth.value
                        }}&ensp;Mbps
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <!-- サブタイトル：リモートアクセスゲートウェイ -->
                <template
                  v-if="intranetFwSelectedItem.remoteAccessGwList.length > 0"
                >
                  <v-row>
                    <v-col>
                      <span class="text-h7 font-weight-bold"
                        >リモートアクセスゲートウェイ</span
                      >
                    </v-col>
                  </v-row>
                  <div class="ml-4">
                    <v-table density="compact">
                      <thead class="v-table-head">
                        <tr>
                          <th class="font-weight-bold">メニュー</th>
                          <th class="font-weight-bold">品目</th>
                          <th class="font-weight-bold">E番号</th>
                          <th class="font-weight-bold">Act/Sby</th>
                          <th class="font-weight-bold">割当帯域</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(
                            remote, index
                          ) in intranetFwSelectedItem.remoteAccessGwList"
                          :key="index"
                        >
                          <tr>
                            <td>
                              {{
                                $filter.enumTo(remote.menu, "remoteAccessGw")
                              }}
                            </td>
                            <td>
                              <span
                                v-if="remote.contractType === 'BESTEFFORT'"
                                >{{ "-" }}</span
                              >
                              <span v-else
                                >{{ remote.contractBandwidth!.value }}Mbps
                              </span>
                            </td>
                            <td>
                              {{ remote.enumberAct }}<br />{{
                                remote.enumberSby
                              }}
                            </td>
                            <td>Act<br />Sby</td>
                            <td>
                              {{ remote.bandwidthActSby.value }}&ensp;Mbps
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </v-table>
                  </div>
                </template>
              </v-card-text>
            </v-card>
            <!-- サブカード：プラットフォームゲートウェイ -->
            <v-card
              class="main-card mt-2"
              v-if="intranetFwSelectedItem.pfgwList.length > 0"
            >
              <v-card-title class="screen-title"
                >プラットフォームゲートウェイ</v-card-title
              >
              <v-card-text>
                <v-sheet
                  v-for="(item, index) in intranetFwSelectedItem.pfgwList"
                  border
                  :key="index"
                  class="mt-4 px-4"
                >
                  <v-row no-gutters justify="end" class="mt-4">
                    <div class="d-flex justify-end ga-1 flex-wrap">
                      <v-btn
                        color="primary"
                        @click="showIntranetFwPfgwZoneRelationList(item)"
                        v-permission.config
                        >ゾーン接続設定</v-btn
                      >
                      <v-btn
                        color="primary"
                        v-permission.notViewDelegate
                        @click="showIntranetFwPfgwZoneAddressEdit(item)"
                        >アドレス設定</v-btn
                      >
                      <v-btn
                        color="primary"
                        v-permission.notViewDelegate
                        @click="
                          showServiceSetting(
                            'INTRANET_FW_PFGW',
                            item.enumberAct
                          )
                        "
                        >個別サービス設定</v-btn
                      >
                      <v-btn
                        color="primary"
                        v-permission.notViewDelegate
                        @click="showIntranetFwPfgwZoneSelectList(item)"
                        >ポリシー設定</v-btn
                      >
                    </div>
                  </v-row>
                  <div class="mt-2">
                    <v-table density="compact">
                      <thead class="v-table-head">
                        <tr>
                          <th class="font-weight-bold">エリア</th>
                          <th class="font-weight-bold">E番号</th>
                          <th class="font-weight-bold">Act/Sby</th>
                          <th class="font-weight-bold">割当帯域</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ item.office }}</td>
                          <td>
                            {{ item.enumberAct }}<br />{{ item.enumberSby }}
                          </td>
                          <td>Act<br />Sby</td>
                          <td>
                            {{ item.bandwidthActSby.value }}&ensp;Mbps<br />{{
                              item.bandwidthActSby.value
                            }}&ensp;Mbps
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-card-text>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ApplianceInfo, ContractAppliances } from "@/apis/ContractApi";
import type {
  Type1Service,
  ContractGetType1Appliance,
} from "@/apis/ContractChangeType1Api";
import type { Type4Service } from "@/apis/ContractChangeType4Api";
import type {
  AccessLine,
  IntranetfwServiceMenu,
  Pfgw,
} from "@/apis/IntranetfwServiceMenuApi";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";
import type { ApplianceInfoWithId } from "@/views/nwSetting/applianceObject/ApplianceObjectList.vue";
import InternetType4ImportConfig from "@/modals/applianceContractSetting/type4/contract/InternetType4ImportConfig.vue";
import InternetType4ContractRegister from "@/modals/applianceContractSetting/type4/contract/InternetType4ContractRegister.vue";
import ContractOptionReference from "@/modals/applianceContractSetting/options/ContractOptionReference.vue";
import InternetType1ZoneRelationSettingList from "@/modals/applianceContractSetting/type1/zoneRelationSetting/InternetType1ZoneRelationSettingList.vue";
import InternetType1ZoneSelectReference from "@/modals/applianceContractSetting/type1/policy/InternetType1ZoneSelectReference.vue";
import InternetType1ContractApplianceModify from "@/modals/applianceContractSetting/type1/appliance/InternetType1ContractApplianceModify.vue";
import InternetType1ContractModify from "@/modals/applianceContractSetting/type1/contract/InternetType1ContractModify.vue";
import InternetType4ContractDeleteConfirm from "@/modals/applianceContractSetting/type4/contract/InternetType4ContractDeleteConfirm.vue";
import InternetType4RouteModify from "@/modals/applianceContractSetting/type4/routeSetting/InternetType4RouteModify.vue";
import InternetType4ContractModify from "@/modals/applianceContractSetting/type4/contract/InternetType4ContractModify.vue";
import InternetType4PolicyUtmList from "@/modals/applianceContractSetting/type4/policy/InternetType4PolicyUtmList.vue";
import InternetType4PolicyIfwList from "@/modals/applianceContractSetting/type4/policy/InternetType4PolicyIfwList.vue";
import IntranetFwContractModify from "@/modals/applianceContractSetting/IntranetFirewall/contract/IntranetFwContractModify.vue";
import IntranetFwZoneRelationList from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/ifw/IntranetFwZoneRelationList.vue";
import IntranetFwPfgwZoneRelationList from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/pfgw/IntranetFwPfgwZoneRelationList.vue";
import IntranetFwCustomServiceList from "@/modals/applianceContractSetting/IntranetFirewall/customService/IntranetFwCustomServiceList.vue";
import IntranetFwPfgwZoneAddressEdit from "@/modals/applianceContractSetting/IntranetFirewall/address/IntranetFwPfgwZoneAddressEdit.vue";
import IntranetFwPolicyZoneList from "@/modals/applianceContractSetting/IntranetFirewall/policy/ifw/IntranetFwPolicyZoneList.vue";
import IntranetFwPfgwPolicyZoneList from "@/modals/applianceContractSetting/IntranetFirewall/policy/pfgw/IntranetFwPfgwPolicyZoneList.vue";

export default defineComponent({
  name: "ApplianceObjectContractSettingList",
  data() {
    return {
      applianceObjectTable: {
        sortBy: { key: "lineNumber", order: "asc" } as SortItem,
        fields: [
          {
            key: "lineNumber",
            title: "回線番号",
            sortable: true,
            width: "120px",
            sortByFormatted: true,
            formatter: (_v: string, _k: string, item: ApplianceInfo) => {
              if (item.internetType === "TYPE1") {
                return `${item.enumberMainAct}\n${item.enumberMainSby}`;
              } else if (item.internetType === "TYPE4") {
                return `${item.wnumberMainAct}\n${item.wnumberMainSby}`;
              } else {
                return null;
              }
            },
          },
          {
            key: "vpnVnCode",
            title: "VPN/VNコード",
            sortable: true,
            width: "150px",
          },
          {
            key: "internetType",
            title: "Type",
            sortable: true,
            width: "180px",
            sortByFormatted: true,
            formatter: (_v: string) => {
              return this.$filter.enumTo(_v, "internetType");
            },
          },
          {
            key: "type4Id",
            title: "Type4ID",
            sortable: true,
            width: "100px",
          },
          {
            key: "type4Name",
            title: "Type4名",
            sortable: true,
            width: "120px",
          },
          {
            key: "mainSite",
            title: "メインサイト",
            sortable: true,
            width: "140px",
          },
          {
            key: "appliance",
            title: "アプライアンス",
            sortable: true,
            width: "200px",
            sortByFormatted: true,
            formatter: (_v: string, _k: string, item: ApplianceInfo) => {
              return this.$filter.applianceTypeTo(
                item.applianceType,
                item.bandwidth
              );
            },
          },
          {
            key: "isSecurityOption",
            title: "セキュリティ監視",
            sortable: true,
            width: "170px",
          },
          {
            key: "status",
            title: "状態",
            sortable: true,
            width: "90px",
            sortByFormatted: true,
            formatter: (_v: string, _k: string, item: ApplianceInfo) => {
              if (item.internetType === "INTRANET") {
                return null;
              } else {
                return this.$filter.internetStatusTo(
                  item.isStart,
                  item.isInternetPause
                );
              }
            },
          },
        ] as AppTableHeader<ApplianceInfoWithId>[],
        items: [] as ApplianceInfoWithId[],
      },

      selectedItem: null as null | ApplianceInfoWithId,
      type1SelectedItem: {} as Type1Service,
      type4SelectedItem: {} as Type4Service,
      intranetFwSelectedItem: {} as IntranetfwServiceMenu,
      /** 初期通信完了フラグ */
      isLoaded: false,
      /** 詳細通信完了フラグ */
      isDetailLoaded: false,
      /** ユーザ設定 */
      user: this.$store.state.user,
      contractGetType1Appliance: {} as ContractGetType1Appliance,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      if (!this.user.contractSummary.isSecuritySetting) {
        /** セキュリティ監視を非表示 */
        this.applianceObjectTable.fields.splice(7, 1);
      }
      /** アプライアンス一覧の取得APIを呼び出し、データ取得を行う */
      this.applianceObjectTable.items = (
        await this.$api.contract.getAppliances()
      ).applianceInfoList.map(
        (e: ContractAppliances["applianceInfoList"][0]) => {
          // テーブルの主キー相当を生成
          switch (e.internetType) {
            case "TYPE1":
              return { ...e, _id: "type1" };
            case "TYPE4":
              return { ...e, _id: `type4_${e.type4Id}` };
            case "INTRANET":
              return { ...e, _id: `intranet` };
          }
        }
      );
    },
    async reload() {
      await this.load();
      if (this.selectedItem) {
        const currentLine = this.applianceObjectTable.items.find(
          (v) => v._id === this.selectedItem!._id
        );
        if (currentLine) {
          await this.setSelectedItem(currentLine);
        } else {
          this.isDetailLoaded = false;
          this.selectedItem = null;
        }
      }
    },
    /** 選択した行の背景色を変更する処理 */
    rowHighlight(item: ApplianceInfoWithId): string[] | undefined {
      if (item._id === this.selectedItem?._id) {
        return ["table-success", "clickable"];
      }
      return ["clickable"];
    },

    /** 契約インポート */
    async showImportContract() {
      await this.$modal.show(InternetType4ImportConfig);
      await this.reload();
    },

    /** 「追加」ボタン */
    async showPolicyRegister() {
      await this.$modal.show(InternetType4ContractRegister, {
        type4Items: this.applianceObjectTable.items.filter(
          (v) => v.internetType === "TYPE4"
        ),
      });
      await this.reload();
    },

    /** 「オプション設定」ボタン */
    async showOptionReference() {
      await this.$modal.show(ContractOptionReference);
    },

    /** 一覧の行選択 */
    async setSelectedItem(row: ApplianceInfoWithId) {
      this.selectedItem = row;
      this.isDetailLoaded = false;
      switch (row.internetType) {
        case "TYPE1":
          this.type1SelectedItem =
            await this.$api.contract_change_type1.getType1Service();
          this.contractGetType1Appliance =
            await this.$api.contract_change_type1.getContractType1Appliance();
          break;
        case "TYPE4":
          if (this.selectedItem.type4Id) {
            this.type4SelectedItem =
              await this.$api.contract_change_type4.getType4Service(
                this.selectedItem.type4Id
              );
            if (
              this.type4SelectedItem.bandwidth &&
              this.type4SelectedItem.bandwidth.value >= 1000
            ) {
              this.type4SelectedItem.bandwidth = {
                value: this.type4SelectedItem.bandwidth.value / 1000,
                unit: "GBPS",
              };
            }
          }
          break;
        case "INTRANET":
          this.intranetFwSelectedItem =
            await this.$api.intranetfwServiceMenu.getIntranetfwServiceMenu();
          /** イントラネットFW帯域の変換と変更画チェックボックスの追加処理 */
          this.intranetFwSelectedItem.intranetFwBandwidth =
            this.bandwidthToMbps(
              this.intranetFwSelectedItem.intranetFwBandwidth
            );
          // 帯域は0の回線が非表示なので、フィルタリングする
          this.intranetFwSelectedItem.accessLineList =
            this.intranetFwSelectedItem.accessLineList.filter(
              (e) => e.bandwidth.value !== 0
            );
          this.intranetFwSelectedItem.accessLineList.forEach((e) => {
            e.bandwidth = this.bandwidthToMbps(e.bandwidth);
            e.isCheck = true;
          });
          this.intranetFwSelectedItem.remoteAccessGwList.forEach((e) => {
            e.bandwidthActSby = this.bandwidthToMbps(e.bandwidthActSby);
            e.contractBandwidth = e.contractBandwidth
              ? this.bandwidthToMbps(e.contractBandwidth)
              : null;
            e.isCheck = true;
          });
          this.intranetFwSelectedItem.pfgwList.forEach((e) => {
            e.bandwidthActSby = this.bandwidthToMbps(e.bandwidthActSby);
            e.isCheck = true;
          });
          break;
      }
      this.isDetailLoaded = true;
    },
    /**
     * イントラネットFW割当帯域変更用Kbps、GbpsからMbpsへ
     */
    bandwidthToMbps(
      bandwidthItem: AccessLine["bandwidth"]
    ): AccessLine["bandwidth"] {
      switch (bandwidthItem.unit) {
        case "KBPS":
          return { value: bandwidthItem.value / 1000, unit: "MBPS" };
        case "MBPS":
          return { value: bandwidthItem.value, unit: "MBPS" };
        case "GBPS":
          return { value: bandwidthItem.value * 1000, unit: "MBPS" };
      }
    },

    /** Type1 ポリシー設定 */
    async showType1PolicySetting() {
      await this.$modal.show(InternetType1ZoneSelectReference, {
        type1Service: this.type1SelectedItem,
      });
    },
    /** Type1 ゾーン接続設定 */
    async showType1ZoneRelationSettingList() {
      await this.$modal.show(InternetType1ZoneRelationSettingList, {
        type1Service: this.type1SelectedItem,
      });
    },

    /** Type1 インターネット接続/一時停止 */
    async changeType1InternetStatus() {
      if (this.type1SelectedItem.status === "INACTIVE") {
        await this.$confirm(
          "インターネットの利用を再開します。よろしいですか？"
        );
        await this.$api.internet_pause.putType1InternetPause({
          isInternetPause: false,
          note: null,
          contractType1KeyId: this.type1SelectedItem.contractType1KeyId,
        });
      } else {
        await this.$confirm(
          "インターネットの利用を一時停止します。よろしいですか？"
        );
        await this.$api.internet_pause.putType1InternetPause({
          isInternetPause: true,
          note: null,
          contractType1KeyId: this.type1SelectedItem.contractType1KeyId,
        });
      }
      await this.reload();
    },

    /** Type1アプライアンス契約 変更 */
    async showType1ContractApplianceModify() {
      await this.$modal.show(InternetType1ContractApplianceModify, {
        contractGetType1Appliance: this.contractGetType1Appliance,
      });
      await this.reload();
    },

    /** Type1 変更 */
    async showType1ContractModify() {
      await this.$modal.show(InternetType1ContractModify, {
        selectedItem: this.type1SelectedItem,
      });
      await this.reload();
    },

    /** Type1 設定情報ダウンロード */
    async downloadNetWorkInformation() {
      const csvData = await this.$api.type1SiteZone.getNetWorkInformation();
      this.$service.file.download(
        this.$service.file.getFileName(csvData)!,
        csvData.data,
        csvData.headers["content-type"]
      );
    },

    /** 設定インポート */
    async showImportConfig() {
      await this.$modal.show(InternetType4ImportConfig, {
        type4Service: this.type4SelectedItem,
      });
    },

    /** Type4 ポリシー設定 */
    async showType4PolicySetting() {
      if (this.type4SelectedItem.applianceType === "UTM") {
        await this.$modal.show(InternetType4PolicyUtmList, {
          type4Id: this.type4SelectedItem.type4Id,
          type4Service: this.type4SelectedItem,
        });
      }
      if (this.type4SelectedItem.applianceType === "IFW") {
        await this.$modal.show(InternetType4PolicyIfwList, {
          type4Id: this.type4SelectedItem.type4Id,
          type4Service: this.type4SelectedItem,
        });
      }
    },

    /** Type4 経路設定 */
    async showType4Route() {
      await this.$modal.show(InternetType4RouteModify, {
        selectedItem: this.type4SelectedItem,
      });
    },

    /** Type4 インターネット接続/一時停止 */
    async changeType4InternetStatus() {
      if (this.type4SelectedItem.status === "UNCONNECTED") {
        await this.$confirm(
          "インターネットの利用を開始します。よろしいですか？"
        );
        await this.$api.contract_change_type4.putType4ServiceStart(
          this.type4SelectedItem.type4Id,
          {
            contractType4KeyId: this.type4SelectedItem.contractType4KeyId,
          }
        );
      } else if (this.type4SelectedItem.status === "INACTIVE") {
        await this.$confirm(
          "インターネットの利用を再開します。よろしいですか？"
        );
        await this.$api.internet_pause.putType4InternetPause(
          this.type4SelectedItem.type4Id,
          {
            isInternetPause: false,
            contractType4KeyId: this.type4SelectedItem.contractType4KeyId,
          }
        );
      } else {
        await this.$confirm(
          "インターネットの利用を一時停止します。よろしいですか？\nインターネット一時停止では課金は停止しないため、課金を停止する場合は契約の解約（削除）をお願いします。"
        );
        await this.$api.internet_pause.putType4InternetPause(
          this.type4SelectedItem.type4Id,
          {
            isInternetPause: true,
            contractType4KeyId: this.type4SelectedItem.contractType4KeyId,
          }
        );
      }
      await this.reload();
    },

    /** Type4 変更 */
    async showType4ContractModify() {
      await this.$modal.show(InternetType4ContractModify, {
        selectedItem: this.type4SelectedItem,
        type4Items: this.applianceObjectTable.items.filter(
          (v) => v.internetType === "TYPE4"
        ),
      });
      await this.reload();
    },

    /** Type4 削除 */
    async showType4PolicyDelete() {
      const putItem = {
        contractType4KeyId: this.type4SelectedItem.contractType4KeyId,
        note: null,
      };
      await this.$modal.show(InternetType4ContractDeleteConfirm, {
        selectedItem: this.type4SelectedItem,
        putItem: putItem,
      });
      await this.$api.contract_change_type4.deleteType4Service(
        this.type4SelectedItem.type4Id,
        putItem
      );
      await this.reload();
    },

    // IntranetFW用メソッド
    /** IntranetFW 契約変更 */
    async showIntranetFwContractChange() {
      await this.$modal.show(IntranetFwContractModify, {
        intranetFwContractItem: this.intranetFwSelectedItem,
      });
      await this.reload();
    },

    /** IntranetFW ゾーン接続設定 */
    async showIntranetFwZoneRelation() {
      await this.$modal.show(IntranetFwZoneRelationList);
      await this.reload();
    },

    /** IntranetFW サービス設定 */
    async showServiceSetting(
      policyType: "INTRANET_FW" | "INTRANET_FW_PFGW",
      enumberAct?: string
    ) {
      await this.$modal.show(IntranetFwCustomServiceList, {
        policyType: policyType,
        enumberAct: enumberAct,
      });
    },

    /** IntranetFW ポリシー設定 */
    async showIntranetFwPolicySetting() {
      await this.$modal.show(IntranetFwPolicyZoneList, {
        contractInfo: {
          vpnCode: this.intranetFwSelectedItem.vpnCode,
          intranetFwBandwidth: this.intranetFwSelectedItem.intranetFwBandwidth,
        },
      });
    },

    /** PFGW ゾーン接続設定 */
    async showIntranetFwPfgwZoneRelationList(pfgw: Pfgw) {
      await this.$modal.show(IntranetFwPfgwZoneRelationList, {
        enumberAct: pfgw.enumberAct,
      });
    },

    /** PFGW アドレス設定 */
    async showIntranetFwPfgwZoneAddressEdit(pfgw: Pfgw) {
      await this.$modal.show(IntranetFwPfgwZoneAddressEdit, {
        enumberAct: pfgw.enumberAct,
      });
    },

    /** PFGW ポリシー設定 */
    async showIntranetFwPfgwZoneSelectList(pfgw: Pfgw) {
      await this.$modal.show(IntranetFwPfgwPolicyZoneList, {
        pfgw: pfgw,
        vpnCode: this.intranetFwSelectedItem.vpnCode,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.v-table {
  tr {
    height: 60px;
  }
}
</style>
